module.exports = __webpack_public_path__ + "static/media/camera-off.92c6963a.svg";